/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ count: NonNullable<unknown> }} Deep_Happy_Snake_BeamInputs */

const en_deep_happy_snake_beam = /** @type {(inputs: Deep_Happy_Snake_BeamInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`+${i?.count} more keywords`)
};

const de_deep_happy_snake_beam = /** @type {(inputs: Deep_Happy_Snake_BeamInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`+${i?.count} weitere Keywords`)
};

/**
* | output |
* | --- |
* | "+{count} more keywords" |
*
* @param {Deep_Happy_Snake_BeamInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const deep_happy_snake_beam = /** @type {((inputs: Deep_Happy_Snake_BeamInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Deep_Happy_Snake_BeamInputs, { locale?: "en" | "de" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_deep_happy_snake_beam(inputs)
	return de_deep_happy_snake_beam(inputs)
});